// Register the service worker and handle install prompt + push subscription.

export function registerServiceWorker() {
  if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .catch((err) => console.warn("SW registration failed", err));
    });
  }
}

let deferredPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  window.dispatchEvent(new CustomEvent("pwa-installable"));
});

export function canInstallPWA() { return !!deferredPrompt; }

export async function promptInstall() {
  if (!deferredPrompt) return false;
  deferredPrompt.prompt();
  const choice = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return choice.outcome === "accepted";
}

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function subscribeToPush(vapidPublicKey) {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return null;
  const reg = await navigator.serviceWorker.ready;
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return null;
  const applicationServerKey = urlB64ToUint8Array(vapidPublicKey);

  // Drop any pre-existing subscription first. If it was made with a different
  // (older / rotated) VAPID key, re-subscribing otherwise throws
  // "Registration failed - push service error" / "A subscription with a
  // different applicationServerKey already exists".
  try {
    const existing = await reg.pushManager.getSubscription();
    if (existing) await existing.unsubscribe();
  } catch (_) { /* best-effort */ }

  const doSubscribe = () => reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  try {
    return await doSubscribe();
  } catch (err) {
    // FCM registration is occasionally transiently flaky — retry once.
    await new Promise((r) => setTimeout(r, 900));
    return await doSubscribe();
  }
}

export async function unsubscribeFromPush() {
  if (!("serviceWorker" in navigator)) return;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) await sub.unsubscribe();
}
